<style>
.parametric-search-header {
    margin-top: 25px !important;
}

@media only screen and (max-width: 767px) {
    .parametric-intro {
        padding-top: 0 !important;
        margin: 0 15px;
    }

    .parametric-search-header {
        margin: 0 15px;
    }
}

.description-content {
    display: block !important;
    margin-bottom: 20px;
}

</style>

<template>
    <div class="row parametric-search-header">
        <div v-if="!isPublic">
            <h3 class="page-title">My Parametric Search</h3>
        </div>
        <div class="content" :class="{'description-content' : !isPublic}"></div>
    </div>
</template>

<script>

export default {
    name: "ParametricSearchHeader",
    props: {
        isPublic: {
            type: Boolean
        }
    },
    mounted() {
        if (this.isPublic) {
            const categoryDescription = document.querySelector('.category-description')
            const contentDiv = document.querySelector('.parametric-search-header .content');
            if (contentDiv && categoryDescription) {
                contentDiv.innerHTML = categoryDescription.innerHTML;
            }
        }
    }
};
</script>
